import { useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import Sidebar from "../components/layout/Sidebar";
import Navbar from "../components/layout/Navbar";
import { useAuth } from "../context/AuthContext";
import {
  getAdminRoutePermissions,
  hasAnyPermission,
  isSuperAdmin,
  isProductionHiddenTool,
} from "../utils/permissions";

export default function AdminLayout({ children }) {
  const location = useLocation();
  const { isLoading, isAuthenticated, user } = useAuth();
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isSidebarHovered, setIsSidebarHovered] = useState(false);

  const requiredPermissions = getAdminRoutePermissions(location.pathname);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="h-10 w-10 rounded-full border-4 border-primary-100 border-t-primary-800 animate-spin" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <Navigate to="/admin/login" replace state={{ from: location.pathname }} />
    );
  }

  if (isProductionHiddenTool(location.pathname)) {
    return <Navigate to="/unauthorized" replace state={{ from: location.pathname }} />;
  }

  if (
    !isSuperAdmin(user) &&
    (requiredPermissions === null ||
      !hasAnyPermission(user, requiredPermissions))
  ) {
    return (
      <Navigate
        to="/unauthorized"
        replace
        state={{ from: location.pathname }}
      />
    );
  }

  return (
    <div className="min-h-screen bg-gray-100">
      <Sidebar
        collapsed={isSidebarCollapsed}
        expanded={!isSidebarCollapsed || isSidebarHovered}
        onMouseEnter={() => setIsSidebarHovered(true)}
        onMouseLeave={() => setIsSidebarHovered(false)}
      />

      <div
        className={`min-h-screen transition-[margin] duration-200 ${
          isSidebarCollapsed ? "ml-20" : "ml-72"
        }`}
      >
        <Navbar
          sidebarCollapsed={isSidebarCollapsed}
          onToggleSidebar={() => setIsSidebarCollapsed((value) => !value)}
        />

        <main className="pt-28 px-8 pb-8">{children}</main>
      </div>
    </div>
  );
}
